import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    Box,
    Stack,
    Type,
} from 'react-spark';

import actionCreator from '../../redux/customize-offers/action-creator';
import { CaretDownIcon } from '../../icons';
import { formatMoney, buildIncrementedList } from '../../../../utils/numbers';

class OffersV2CustomizeComponent extends Component {
    static propTypes = {
        clientStateMinAmount: PropTypes.number.isRequired,
        customizedOffer: PropTypes.number,
        maxOffer: PropTypes.number.isRequired,
        minOffer: PropTypes.number,
        submit: PropTypes.func.isRequired,
        selectionHighToLow: PropTypes.bool,
        requestedAmountAvailable: PropTypes.bool,
    };

    static defaultProps = {
        selectionHighToLow: false,
        requestedAmountAvailable: false,
    };

    get customLoanAmounts() {
        const { maxOffer, selectionHighToLow } = this.props;
        const baseList = buildIncrementedList(
            this.lowestLoanAmount,
            maxOffer,
            500
        );
        return selectionHighToLow ? baseList.reverse() : baseList;
    }

    get lowestLoanAmount() {
        const { clientStateMinAmount, minOffer } = this.props;
        return Math.max(minOffer || 0, clientStateMinAmount);
    }

    renderOptions() {
        const options = this.customLoanAmounts.map((value) => (
            <option key={value} value={value}>
                {formatMoney(value)}
            </option>
        ));

        // Insert the placeholder option at the beginning
        options.unshift(
            <option key="Loan Amount" value="Loan Amount" disabled>
                Loan Amount
            </option>
        );
        return options;
    }

    render() {
        const {
            customizedOffer,
            requestedAmountAvailable
        } = this.props;

        return (
            <Box id='customize-offers' className="sprk-u-pvl">
                <Stack splitAt='small' itemSpacing='medium'>
                    <Stack.Item className='sprk-o-Stack sprk-o-Stack__item--half@s'>
                        <Type.DisplayFive style={{ fontSize: '1.4rem' }} className='sprk-o-Stack__item sprk-u-mts'>
                            Looking for another amount?
                        </Type.DisplayFive>
                        <Type.BodyFour className='sprk-o-Stack__item'>
                            Choose an amount to see offer details.
                        </Type.BodyFour>
                    </Stack.Item>
                    <Stack.Item className='sprk-o-Stack__item--half@s'>
                        <Box
                            padding='flush'
                            className='sprk-u-Position--relative sprk-u-BackgroundColor--gray'
                            style={{ maxWidth: '425px', margin: 'auto' }}
                            >
                            <CaretDownIcon
                                className='sprk-u-Top--1/2 sprk-u-Right--zero
                                    sprk-u-Position--absolute sprk-u-mrm'
                                style={{ width: 10, height: 6, marginTop: -3}} />
                            <select
                                id='customize-loan-select'
                                className='sprk-u-Position--relative sprk-u-BackgroundColor--none
                                    sprk-u-Width-100 ssprk-b-TypeBodyTwo sprk-u-prl sprk-u-plm
                                    sprk-u-pvm sprk-u-man sprk-u-Border--0 sprk-u-Border-b--1
                                    sprk-u-BorderColor--black-tint-50 sprk-u-Rounded--0 sprk-b-Select'
                                style={{ appearance: 'none'}}
                                defaultValue={requestedAmountAvailable ? customizedOffer : 'Loan Amount'}
                                onChange={({ target }) => {
                                    const amount = target.value.replace(/[^\d.]/g, '');
                                    this.props.submit(amount);
                                }}>
                                {this.renderOptions()}
                            </select>
                        </Box>
                    </Stack.Item>
                </Stack>
            </Box>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    submit: (requestedAmount) => dispatch((_, getState) => {
        const state = getState();
        if (state && state.loan && state.loan.loanJson && state.loan.loanJson.loanId) {
            dispatch(actionCreator.submitAuthenticated(requestedAmount, state.loan.loanJson.loanId));
        } else {
            dispatch(actionCreator.submit(requestedAmount));
        }
    }),
});

export const OffersV2Customize = connect(
    null,
    mapDispatchToProps
)(OffersV2CustomizeComponent);
